export function CircleUserFilled(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.3098 28.3464C27.871 25.8464 25.1692 24.1667 22.0833 24.1667H17.9166C14.8306 24.1667 12.1288 25.8464 10.69 28.3464C12.9817 30.8985 16.302 32.5 19.9999 32.5C23.6978 32.5 27.0181 30.892 29.3098 28.3464ZM36.6666 20C36.6666 29.2058 29.2056 36.6667 19.9999 36.6667C10.7942 36.6667 3.33325 29.2058 3.33325 20C3.33325 10.7943 10.7942 3.33337 19.9999 3.33337C29.2056 3.33337 36.6666 10.7943 36.6666 20ZM19.9999 21.0417C22.5911 21.0417 24.6874 18.9454 24.6874 16.3542C24.6874 13.7631 22.5911 11.6667 19.9999 11.6667C17.4088 11.6667 15.3124 13.7631 15.3124 16.3542C15.3124 18.9454 17.4088 21.0417 19.9999 21.0417Z"
        fill="black"
      />
    </svg>
  );
}
